// // import React from "react";

// // import {
// //   Card,
// //   CardBody,
// //   Content,
// //   Grid,
// //   GridItem,
// //   List,
// //   ListItem,
// //   PageSection,
// //   Stack,
// //   StackItem
// // } from "@patternfly/react-core";

// // import {
// //   ExternalLinkAltIcon
// // } from "@patternfly/react-icons";

// // import { teacherDocuments } from "./data/teacherDocuments";


// // const TeacherPage = () => {
// //   return (
// //     <PageSection isWidthLimited>
// //       <Stack hasGutter>
// //         <StackItem>
// //           <Grid>
// //             <GridItem span={12} md={8} mdOffset={2}>
// //               <Content style={{ textAlign: "center" }}>
// //                 <h1>Dla nauczyciela</h1>

// //                 <p>
// //                   Dokumenty, regulaminy i procedury dla nauczycieli.
// //                 </p>
// //               </Content>
// //             </GridItem>
// //           </Grid>
// //         </StackItem>

// //         <StackItem>
// //           <Grid>
// //             <GridItem
// //               span={12}
// //               md={10}
// //               mdOffset={1}
// //               lg={8}
// //               lgOffset={2}
// //             >
// //               <Card>
// //                 <CardBody>
// //                   <Content>
// //                     <List isPlain>
// //                       {teacherDocuments.map((document) => (
// //                         <ListItem key={document.id}>
// //                           <a
// //                             href={document.href}
// //                             target="_blank"
// //                             rel="noopener noreferrer"
// //                           >
// //                             {document.title}{" "}
// //                             <ExternalLinkAltIcon />
// //                           </a>
// //                         </ListItem>
// //                       ))}
// //                     </List>
// //                   </Content>
// //                 </CardBody>
// //               </Card>
// //             </GridItem>
// //           </Grid>
// //         </StackItem>
// //       </Stack>
// //     </PageSection>
// //   );
// // };


// // export default TeacherPage;

// import React from "react";

// import {
//   Card,
//   CardBody,
//   Content,
//   Divider,
//   Grid,
//   GridItem,
//   List,
//   ListItem,
//   PageSection,
//   Stack,
//   StackItem
// } from "@patternfly/react-core";

// import {
//   ExternalLinkAltIcon
// } from "@patternfly/react-icons";

// import {
//   teacherDocumentGroups
// } from "./data/teacherDocuments";


// const TeacherPage = () => {
//   return (
//     <PageSection isWidthLimited>
//       <Stack hasGutter>
//         <StackItem>
//           <Grid>
//             <GridItem span={12} md={8} mdOffset={2}>
//               <Content style={{ textAlign: "center" }}>
//                 <h1>Dla nauczyciela</h1>

//                 <p>
//                   Dokumenty, regulaminy i procedury dla nauczycieli.
//                 </p>
//               </Content>
//             </GridItem>
//           </Grid>
//         </StackItem>

//         <StackItem>
//           <Grid>
//             <GridItem
//               span={12}
//               md={10}
//               mdOffset={1}
//               lg={8}
//               lgOffset={2}
//             >
//               <Card>
//                 <CardBody>
//                   <Stack hasGutter>
//                     {teacherDocumentGroups.map((group, index) => (
//                       <React.Fragment key={group.id}>
//                         {index > 0 && (
//                           <StackItem>
//                             <Divider />
//                           </StackItem>
//                         )}

//                         <StackItem>
//                           <Stack hasGutter>
//                             <StackItem>
//                               <Content>
//                                 <h2>{group.title}</h2>
//                               </Content>
//                             </StackItem>

//                             <StackItem>
//                               <Content>
//                                 <List isPlain>
//                                   {group.documents.map((document) => (
//                                     <ListItem key={document.id}>
//                                       <a
//                                         href={document.href}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                       >
//                                         {document.title}{" "}
//                                         <ExternalLinkAltIcon />
//                                       </a>
//                                     </ListItem>
//                                   ))}
//                                 </List>
//                               </Content>
//                             </StackItem>
//                           </Stack>
//                         </StackItem>
//                       </React.Fragment>
//                     ))}
//                   </Stack>
//                 </CardBody>
//               </Card>
//             </GridItem>
//           </Grid>
//         </StackItem>
//       </Stack>
//     </PageSection>
//   );
// };


// export default TeacherPage;

import React from "react";


import {
  Card,
  CardBody,
  Content,
  Divider,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";


import {
  ExternalLinkAltIcon
} from "@patternfly/react-icons";


import {
  teacherDocumentGroups
} from "./data/teacherDocuments";


const DocumentGroups = ({ groups }) => {
  return (
    <Stack hasGutter>
      {groups.map((group, index) => (
        <React.Fragment key={group.id}>
          {index > 0 && (
            <StackItem>
              <Divider />
            </StackItem>
          )}

          <StackItem>
            <Stack hasGutter>
              <StackItem>
                <Content>
                  <h2>{group.title}</h2>
                </Content>
              </StackItem>

              <StackItem>
                <Content>
                  <List isPlain>
                    {group.documents.map((document) => (
                      <ListItem key={document.id}>
                        <a
                          href={document.href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {document.title}{" "}
                          <ExternalLinkAltIcon />
                        </a>
                      </ListItem>
                    ))}
                  </List>
                </Content>
              </StackItem>
            </Stack>
          </StackItem>
        </React.Fragment>
      ))}
    </Stack>
  );
};


const TeacherPage = () => {
  const firstColumnGroups = teacherDocumentGroups.slice(0, 2);
  const secondColumnGroups = teacherDocumentGroups.slice(2);


  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem span={12} md={8} mdOffset={2}>
              <Content style={{ textAlign: "center" }}>
                <h1>Dla nauczyciela</h1>

                <p>
                  Dokumenty, regulaminy i procedury dla nauczycieli.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
              lg={10}
              lgOffset={1}
            >
              <Grid hasGutter>
                <GridItem span={12} md={6}>
                  <Card isFullHeight isGlass>
                    <CardBody>
                      <DocumentGroups
                        groups={firstColumnGroups}
                      />
                    </CardBody>
                  </Card>
                </GridItem>

                <GridItem span={12} md={6}>
                  <Card isFullHeight isGlass>
                    <CardBody>
                      <DocumentGroups
                        groups={secondColumnGroups}
                      />
                    </CardBody>
                  </Card>
                </GridItem>
              </Grid>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default TeacherPage;